const apiUrl = '/api'

class URL {
	constructor(base) {
		this.base = base
	}

	path(path, args) {
		path = path.split('.')
		let obj = this,
			url = this.base

		for (let i = 0; i < path.length && obj; i++) {
			if (obj.url) {
				url += '/' + obj.url
			}

			obj = obj[path[i]]
		}
		if (obj) {
			url = url + '/' + (typeof obj === 'string' ? obj : obj.url)
		}

		if (args) {
			for (let key in args) {
				url = url.replace(':' + key, args[key])
			}
		}

		return url
	}
}

export const api = Object.assign(new URL(apiUrl), {
	url: 'admin',

	auth: {
		url: 'auth',

		me: 'me',
		admin_login: 'admin-login',

		logout: 'logout',
		states: 'get_states'
	},

	core: {
		url: 'core',

		countries: 'getCountries',
		country_list: 'countryList',
		update_country: 'updateCountry',
	},

	member: {
		url: 'member',

		list: 'list',
		create: 'create',
		detail: 'detail/:id',
		reset_pwd: 'resetPassword',
		valid_username: 'validateUsername',
		change_username: 'changeUsername'
	},

	category: {
		url: 'category',

		list: 'list',
		create: 'create',
		update: 'update',
		getCategory: 'getCategory/:id',
	},

	product: {
		url: 'product',

		list: 'list',
		create: 'create',
		update: 'update',
		getProduct: 'getProduct/:id',
		category: 'getCategoryByCompanyId/:id',
		upload: 'uploadMedia',
	},

	merchant: {
		url: 'merchant',

		list: 'list',
		create: 'create',
		detail: 'detail/:id',
		update: 'update',
		setting: 'setting/:id',
		update_setting: 'update-setting/:id',

		upload: 'upload',
		approve: 'approve',
		resend: 'resend-email',
	},

	// Banner Module
	banner: {
		url: 'banner',

		list: 'list',
		create: 'create',
		detail: 'detail/:id',
		update: 'update',

		upload: 'upload',
	},

	order: {
		url: 'order',

		list: 'list',
		detail: 'detail/:id',
		update: 'update',
	},

	// Permission Module
	permission: {
		url: 'permission',

		index: '',
	},

	lookup: {
		url: 'lookup',

		state: 'state',
    }
})
